// Brillenhaus – "Passt sie mir?": vergleicht die Maße der Brille mit der eigenen Brille.
// Die eingegebenen Werte bleiben im Browser gespeichert (nur auf diesem Gerät).
const STORAGE_KEY = 'bh-eigene-brille';

function readSaved() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function save(values) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(values));
  } catch {
    /* Speicher nicht verfügbar – Vergleich funktioniert trotzdem */
  }
}

function describe(diff, wider, narrower) {
  const abs = Math.abs(diff);
  if (abs <= 3) return { text: 'Fast genau so groß wie deine Brille', match: true };
  const amount = `${abs} mm`;
  if (abs <= 8) return { text: `Etwas ${diff > 0 ? wider : narrower} als deine Brille (${diff > 0 ? '+' : '−'}${amount})`, match: false };
  return { text: `Deutlich ${diff > 0 ? wider : narrower} als deine Brille (${diff > 0 ? '+' : '−'}${amount})`, match: false };
}

function render(root) {
  const frame = {
    glas: Number(root.dataset.glas),
    steg: Number(root.dataset.steg),
    buegel: Number(root.dataset.buegel) || 0,
  };
  const inputs = root.querySelectorAll('[data-fit-input]');
  const values = {};
  inputs.forEach((input) => {
    values[input.dataset.fitInput] = Number(input.value) || 0;
  });

  const result = root.querySelector('[data-fit-result]');
  const inline = root.querySelector('[data-fit-inline]');
  if (!values.glas || !values.steg) {
    result.innerHTML = '';
    inline.classList.remove('is-match', 'is-diff');
    inline.textContent = inline.dataset.defaultText;
    return;
  }

  // Vordere Breite ≈ zwei Gläser plus Steg – das ist der Teil, der über das Gesicht entscheidet.
  const front = frame.glas * 2 + frame.steg;
  const yours = values.glas * 2 + values.steg;
  const verdict = describe(front - yours, 'breiter', 'schmaler');

  let temple = '';
  if (frame.buegel && values.buegel) {
    const t = frame.buegel - values.buegel;
    temple = Math.abs(t) <= 5 ? 'Bügellänge passt zu deiner Brille.' : `Bügel ${Math.abs(t)} mm ${t > 0 ? 'länger' : 'kürzer'} als bei deiner Brille.`;
  }

  const max = Math.max(front, yours) * 1.08;
  result.innerHTML = `
    <p class="bh-fit__verdict">${verdict.text}</p>
    <div class="bh-fit__bars">
      <div class="bh-fit__bar"><span>Diese Brille</span><span class="bh-fit__track"><span class="bh-fit__fill" style="width:${(front / max) * 100}%"></span></span></div>
      <div class="bh-fit__bar"><span>Deine Brille</span><span class="bh-fit__track"><span class="bh-fit__fill bh-fit__fill--yours" style="width:${(yours / max) * 100}%"></span></span></div>
    </div>
    ${temple ? `<p class="bh-fit__note">${temple}</p>` : ''}`;
  inline.textContent = verdict.text;
  inline.classList.toggle('is-match', verdict.match);
  inline.classList.toggle('is-diff', !verdict.match);
}

function init(root) {
  if (root.dataset.fitReady) return;
  root.dataset.fitReady = 'true';
  const inline = root.querySelector('[data-fit-inline]');
  if (!inline) return;
  inline.dataset.defaultText = inline.textContent;

  const saved = readSaved();
  root.querySelectorAll('[data-fit-input]').forEach((input) => {
    if (saved[input.dataset.fitInput]) input.value = saved[input.dataset.fitInput];
    input.addEventListener('input', () => {
      const values = {};
      root.querySelectorAll('[data-fit-input]').forEach((i) => (values[i.dataset.fitInput] = i.value));
      save(values);
      render(root);
    });
  });
  render(root);
}

document.querySelectorAll('.bh-fit').forEach(init);
new MutationObserver(() => document.querySelectorAll('.bh-fit').forEach(init)).observe(document.body, {
  childList: true,
  subtree: true,
});
